import { useState, useEffect } from "react";
import { Button, Stack, Box, TextField, Switch, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import doc from "../../assets/image/doc.png";

export default function PdfGenerator({
  setImages,
  setImagesValue,
  setFiles,
  setFilesValue,
  switchStates,
  setSwitchStates,
}) {
  const [localImages, setLocalImages] = useState([]);
  const [localImgValue, setLocalImgValue] = useState("");
  const [localFiles, setLocalFiles] = useState();
  const [localFileValue, setLocalFileValue] = useState("");

  const handleMediaChange = (event) => {
    const files = Array.from(event.target.files);
    const newImages = files.map((file) => URL.createObjectURL(file));
    const updatedImages = [...localImages, ...newImages];

    setLocalImages(updatedImages);
    setImages(updatedImages);
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setLocalFiles(file);
      setFiles(file);
    }
  };

  const handleToggle = () => {
    setSwitchStates(!switchStates);
  };

  useEffect(() => {
    setLocalImgValue("");
    setLocalImages([]);
    
    setLocalFiles();
    setLocalFileValue("");

    setFiles();
    setFilesValue("");

    setImages([]);
    setImagesValue("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [switchStates]);

  const RedSwitch = styled(Switch)({
    "& .Mui-checked": {
      color: "#d32f2f !important",
    },
    "& .Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#d32f2f !important",
    },
  });

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        overflow: "auto",
      }}
    >
      <Box
        sx={{
          mb: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{ paddingRight: "40px", color: "#fff", fontSize: "16px", fontFamily: "Montserrat" }}
        >
          Файл
        </Typography>
        <RedSwitch checked={switchStates} onChange={() => handleToggle()} />
        <Typography
          sx={{ paddingLeft: "40px", color: "#fff", fontSize: "16px", fontFamily: "Montserrat" }}
        >
          Медиа
        </Typography>
      </Box>
      {switchStates ? (
        <>
          <Stack spacing={2} alignItems="center" marginBottom={3}>
            <input
              accept="image/*"
              id="upload-file"
              multiple
              type="file"
              hidden
              onChange={handleMediaChange}
            />
            <label htmlFor="upload-file">
              <Button variant="contained" component="span" startIcon={<CloudUploadIcon />}>
                Загрузить фото
              </Button>
            </label>
          </Stack>

          <TextField
            label="Название файла*"
            value={localImgValue}
            variant="outlined"
            onChange={(e) => {
              setImagesValue(e.target.value);
              setLocalImgValue(e.target.value);
            }}
            fullWidth
            sx={{ mb: 2, color: "#fff" }}
          />

          <Stack direction="row" justifyContent="space-between" spacing={1} flexWrap="wrap">
            {localImages.map((src, index) => (
              <img
                key={index}
                src={src}
                alt="Captured"
                style={{
                  width: 100,
                  borderRadius: 8,
                  marginBottom: 15,
                  marginLeft: 10,
                  marginRight: 10,
                }}
              />
            ))}
          </Stack>
        </>
      ) : (
        <>
          <Stack spacing={2} alignItems="center" marginBottom={3}>
            <input
              accept=".pdf,.doc,.docx,.txt"
              id="upload-file"
              type="file"
              hidden
              onChange={handleFileChange}
            />
            <label htmlFor="upload-file">
              <Button variant="contained" component="span" startIcon={<CloudUploadIcon />}>
                Загрузить файл
              </Button>
            </label>
          </Stack>

          <TextField
            label="Название файла*"
            variant="outlined"
            value={localFileValue}
            onChange={(e) => {
              setLocalFileValue(e.target.value);
              setFilesValue(e.target.value);
            }}
            fullWidth
            sx={{ mb: 2, color: "#fff" }}
          />

          <Stack direction="row" justifyContent="space-between" spacing={1} flexWrap="wrap">
            {localFiles && (
              <Box
                sx={{
                  mb: 1,
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <img src={doc} alt="doc" style={{ width: "60px" }} />
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "16px",
                    fontFamily: "Montserrat",
                  }}
                >
                  {localFiles.name}
                </Typography>
              </Box>
            )}
          </Stack>
        </>
      )}
    </Box>
  );
}
